import { render, staticRenderFns } from "./pointAccount.vue?vue&type=template&id=42a20dc4&"
import script from "./pointAccount.vue?vue&type=script&lang=js&"
export * from "./pointAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports